module.exports = {
  "large-customer-support": {
    name: "large-customer-support",
    width: 348,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-customer-support.5cef11101414be46a3c958f6fd7f802556ba24f6@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-customer-support.8711f0ffa5af2225b19f01ba991ab2729f3c58e7@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-customer-support.08a9061c8b607fdd1f765ee1fd6b417a9c830275@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-customer-support.702a2ea7c7977048e3a154c728a2030ded8cfb2f@1x.png"
  },
  "large-delivery-van": {
    name: "large-delivery-van",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-delivery-van.628a82bc03796259b606dbf435b91706b939322a@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-delivery-van.a494561284703b226c73f1cf69f9338a139c9cdf@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-delivery-van.c8e2ee00e137254373980da3e6d9da090e9aa7ec@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-delivery-van.d00935975068529736cd4e3f95b71fc756bc207c@1x.png"
  },
  "large-echo-team": {
    name: "large-echo-team",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-echo-team.79bf6ad61a21fdd20f6924bfc074c44c9c539205@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-echo-team.6f51b8427d8db30496705b51671bdc9bb0e79ecf@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-echo-team.d7ea0c8ae3254835ac90989d58d2b33f255f6f52@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-echo-team.02b57e43c947bfb40529fa670a72ad717f81d0b6@1x.png"
  },
  "large-home-delivery": {
    name: "large-home-delivery",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-home-delivery.d4eb9ddd5f5dd4ced1f879ac454e46bbcfcd80f4@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-home-delivery.1ef90a47a684f4e79a64b8dc0946656c755c674a@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-home-delivery.ec1987454482eda3e3a545999a18203bca24addf@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-home-delivery.49a49c5146375fa617f95199d7b5c53accecceed@1x.png"
  },
  "large-next-of-kin": {
    name: "large-next-of-kin",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-next-of-kin.4927ac8a2df5c8a87407bda0c31256347e9a2522@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-next-of-kin.2a43c01fa067e85979691d46bd5ef2742b029099@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-next-of-kin.1a1642ab7ab82c9128eb9b7571262dba4b1e8c18@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-next-of-kin.ffbf7e6a7ff4c95e1fbd9007b49c312327f6091c@1x.png"
  },
  "large-person-on-bike": {
    name: "large-person-on-bike",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-on-bike.a0b4d993b4bb6c5b01ac8d6314dc8899c183472a@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-on-bike.3d6926bc509160fcdf110378d88faae43034511b@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-on-bike.4989ddf4e5be50e4bb414787d8c377548933a6d4@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-on-bike.8e21bb93a355cbe44ef0a1bc8420f2c5469d8637@1x.png"
  },
  "large-person-sitting-back-alt": {
    name: "large-person-sitting-back-alt",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back-alt.a6bd6810f00ae353fdba29209521c2a597ddcf6f@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back-alt.20f6927e9b1201c683acd0bff282e0121befcb52@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back-alt.fc75606dbd8ee187a142484b989044fd4888ea2f@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back-alt.03f77053e2f1b318efa0240b4b06efe4a0218f1f@1x.png"
  },
  "large-person-sitting-back": {
    name: "large-person-sitting-back",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back.7a12f8f19a5a227e4b44bafbd4aee2616cee9c38@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back.60f1ef3afd3852d6052363dd9288a6e5f865c7e1@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back.273c07525d5708bf60f1839385e9a4c9530a7316@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-sitting-back.09c9da4d6b1f76c4838b9252463bea711c3be55c@1x.png"
  },
  "large-person-with-parcel-alt": {
    name: "large-person-with-parcel-alt",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-alt.a6505aed91365f799440c705420fa9022d4ad231@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-alt.e5bab7658d4955c17908dd54b0c771346b9aba96@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-alt.03725f342408cea2a2f965ee6f9156db3f8a317e@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-alt.09af6a9cff5a43baf6c0882cc57c4e146fb7d017@1x.png"
  },
  "large-person-with-parcel-collection-point": {
    name: "large-person-with-parcel-collection-point",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-collection-point.b9fee56df63ee3704fecf5f6fc065a38d5594c88@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-collection-point.25a620587f35987122249803a8df0e543331c399@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-collection-point.ef7638cf7908efe40f764381c578d8eded7a5124@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel-collection-point.6f5c41a5e4b47ea9ece3c21ce1c86de22704589d@1x.png"
  },
  "large-person-with-parcel": {
    name: "large-person-with-parcel",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel.6c3254a07a2224183d981828ab80d6fb3ac057fe@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel.d34114f4af65ceb18ded5d4dee7e32efe6b2f5cd@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel.c9f4020fcd5a7be0366a94cba3d52864cae805bf@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-parcel.a27c83c76af520e78403ff16446c48a44624bfc0@1x.png"
  },
  "large-person-with-payment-card-alt": {
    name: "large-person-with-payment-card-alt",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card-alt.53d6fa3b2f4ebb6590aae2288d166c6d34c2d476@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card-alt.174858fdd6f49bb94d6c2fa8ff76e8e48db4569f@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card-alt.2a71b2d330a44ea7c33c18a1e56393b06caf3ccb@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card-alt.f37a9ede23d710a920ee04229c2c197a7599e12c@1x.png"
  },
  "large-person-with-payment-card": {
    name: "large-person-with-payment-card",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card.2d2ed23f74c3b481fdd54e0da9fc07ccb6d9ef7b@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card.cadffe317eeb9353c09cd07ed89c9f71388b85b4@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card.a48dbe603a23bdf004cfee145a7575fec1be4021@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-person-with-payment-card.7b7ce2bdc78b0245f1a1851928475898404cc32a@1x.png"
  },
  "large-pharmacist-checking-alt": {
    name: "large-pharmacist-checking-alt",
    width: 348,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking-alt.87bdfb9fd49d14c21407e837380ed9c56ddb8d87@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking-alt.fb3625ccc39082c4ec0ca386b9b07f68cd8c6a06@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking-alt.5b8ee102440cc0aeef65abee3f800b7797d964d5@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking-alt.fff1557acd710543a1813ea4704fe8af32f3f61d@1x.png"
  },
  "large-pharmacist-checking": {
    name: "large-pharmacist-checking",
    width: 348,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking.70ec8cc80548a28e2b95c1b581aa14d57b26e3f3@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking.50c283c5e62e71c3913ec2fd111741864ac0a75a@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking.e55608c88597e7cde97efcc4e5ef9a56aa568699@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-checking.daee9dc1753bdb922627b71542256b9c2fdb3273@1x.png"
  },
  "large-pharmacist-holding-empty-medicine": {
    name: "large-pharmacist-holding-empty-medicine",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-empty-medicine.79e0e1e34c474c635cdd26ceba117b602543cf28@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-empty-medicine.445542adff3b1ba276fd8c6efeb255588713c8f2@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-empty-medicine.23f247dfdb46c7e00bbfdc8c4e5513c9fa62c4ee@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-empty-medicine.841b6dcc9a4a9353a48809c489730c1a684e28e3@1x.png"
  },
  "large-pharmacist-holding-medicine-with-device": {
    name: "large-pharmacist-holding-medicine-with-device",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine-with-device.741726b378be84d32d32f42f27b91a5035c2accf@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine-with-device.d0e94948a6a784f218a703421ef84984047e5880@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine-with-device.4ed9c0718514baf4720f625ed83e9d05475dc0db@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine-with-device.ef7afc4d1a8fb5f504e356cf0169fa76d1774350@1x.png"
  },
  "large-pharmacist-holding-medicine": {
    name: "large-pharmacist-holding-medicine",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine.616cffc8699dbb1e656476ec35ce9a07e15dbb4a@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine.36932d0a0ac597f74882cf5d1e6f0462c2773b01@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine.f03c1b0c4a5d3a352a4155bd16f7c1eb9c8fd7e0@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-holding-medicine.d7202cbc622e59d0241d7f71f7f4ada1d123b512@1x.png"
  },
  "large-pharmacist-waiting": {
    name: "large-pharmacist-waiting",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waiting.a1e4973c784c0c8221dc6000f1fafcf56cff4492@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waiting.e691852ea17c7fd60e0ede32bbcbc67f86da4c1e@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waiting.52998f9ff53301bf7bedd4f609e4e096fb10a0d9@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waiting.2503433574f2c5f24b6159bcc4f1b5c4b56fc906@1x.png"
  },
  "large-pharmacist-waving-empty-tote-alt": {
    name: "large-pharmacist-waving-empty-tote-alt",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote-alt.8b1ef8dd1f9ceba3335c0d3b214397323626b0b3@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote-alt.5101ea3804200f46cca7010f5bf48c5819dc2214@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote-alt.8887aad04a55a223abd36f3f41370b611dbe8599@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote-alt.d3c635ffa6890017fc5e77cec2154da197072219@1x.png"
  },
  "large-pharmacist-waving-empty-tote": {
    name: "large-pharmacist-waving-empty-tote",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote.a60a1ed16e1c7381cbcdfc69651936e24cf7f471@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote.b22132c4f068c98a13f4c5cd8e2c00852262104f@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote.06d98a5d21459db35ff1d2b18eba1f1e1a73dc0d@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-empty-tote.28345dcb19240c28e78651888d3e7a2aa063c882@1x.png"
  },
  "large-pharmacist-waving-full-tote": {
    name: "large-pharmacist-waving-full-tote",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-full-tote.9f20130b905fb627a771836ed8aa9ea44e8c546d@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-full-tote.fd603d6cead965cf8d4d07d7d1edacad9963cef8@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-full-tote.3814cf05c347d8c1d13731acab0741c035d6f55d@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-pharmacist-waving-full-tote.6e18bb01c95bd4af077e53ea05923a1fa4b40abe@1x.png"
  },
  "large-picking-medicine-blister-selected": {
    name: "large-picking-medicine-blister-selected",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-blister-selected.66c1d040d3379ffedeb62eb3e5e82c96e04574e1@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-blister-selected.dc8280d30bff1607d6ca1d9ca9c70893d9737bf5@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-blister-selected.d7b0711d3613bfffe762ca00a725591c440d0034@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-blister-selected.ad9768e813df0f55a36da32070291917f978aac0@1x.png"
  },
  "large-picking-medicine-box-selected": {
    name: "large-picking-medicine-box-selected",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-selected.2c9065ff9d21519a3290e14bcd08e6a2d88ad8e3@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-selected.1b10b7daec18e166c026ab623bb0514077819448@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-selected.c345695ca233294ecdf8d8c6804438df74729880@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-selected.4af20f55df3c4a330f22483c704395507b3a76c7@1x.png"
  },
  "large-picking-medicine-box-unselected": {
    name: "large-picking-medicine-box-unselected",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-unselected.0a9a44e1b61ab0f91d636fc7f8944954aa3380be@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-unselected.fb70b910b044be55400f7bbc7941a2e463834fce@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-unselected.ced93583a78eb03dfc418ac8b137b05236d1a6c3@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-box-unselected.220f8ecbceac7d5bee673be5a4e225b116d98365@1x.png"
  },
  "large-picking-medicine-inhaler-selected": {
    name: "large-picking-medicine-inhaler-selected",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-inhaler-selected.2a717f4121fbc687c5f84b64f0e9306eef704d94@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-inhaler-selected.472416e32e57e7e133f845cee6ff8f1a97040a54@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-inhaler-selected.5343ed9fdb53ad2b0e916e104251f76719e8d4cb@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-inhaler-selected.d1fcb2da71cef5dbaa5fb784124e5f51eb9aba93@1x.png"
  },
  "large-picking-medicine-with-tote": {
    name: "large-picking-medicine-with-tote",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-with-tote.fb92bcfac8d6d0b0fd0488aaf12286bb93e15e53@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-with-tote.83c2d37fe4b241713067be4eb6048e13f31009fa@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-with-tote.6292c145444969c275188bea9f85d3b36930246b@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-picking-medicine-with-tote.715a7878c1604c8497c0f71fd793a2f6e80250cc@1x.png"
  },
  "large-security": {
    name: "large-security",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-security.f9a9a7baf13f59b3e3d35de07e8d4333bb5928f8@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-security.dbcf9d92132a82f55fc5f6db7d7be4ef1e3c0822@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-security.a58ccdcf1a205dd7a355d6949249124e85bf81e2@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-security.421647347540720549f01b645d41fb180cc69314@1x.png"
  },
  "large-something-went-wrong-1": {
    name: "large-something-went-wrong-1",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-1.07a5b27c41bcd018a5c7c95bd9fc291a1c4da89d@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-1.8cf1d9c8866afbbf80efe051aa69629caa099d9a@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-1.4f4fe49655e4bf467d841ff27d77bce04e8064c6@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-1.71d78b97958012b000b7ac5875a933ae67f733e2@1x.png"
  },
  "large-something-went-wrong-2": {
    name: "large-something-went-wrong-2",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-2.e6a6dd1a5478f291339c03fa0afd9b83eff091e1@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-2.37d89792e0444d09f45cb9bec441598b3a53fee5@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-2.76391b6817b0d2b3ed82ed5411c4b7d9a782a09c@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-something-went-wrong-2.639cce24333536365c3fdbd446638c791dade019@1x.png"
  },
  "large-tote-empty": {
    name: "large-tote-empty",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-empty.697e55cd3397acc97dce5e9941a60c21943a2493@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-empty.a468073aba7c11e9d8beb9af08c2083f6422bf2f@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-empty.68989eb07e838033267156bff9803773240788ad@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-empty.fad46e0a25965f619dce04518a862ee6d0e87139@1x.png"
  },
  "large-tote-full": {
    name: "large-tote-full",
    width: 343,
    height: 218,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-full.612206b2ca8c83248d85a465c725e6c4bbfb73a7@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-full.a35cfea7762d1a6f60f518947b291fcf62352c31@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-full.b40ce549374f517f8a1b963d6f7b7030619a94b4@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/large-tote-full.1ac1fa99e7960cfa3120789bef2d5e15c05e6a9e@1x.png"
  },
  "medium-account": {
    name: "medium-account",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-account.37954c1a88d8e16abb85f78ffdaa40afcabeea2f@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-account.8eb27d44f9decd0cadddbdd02ba4f98e04c8ca31@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-account.90c6c3dfad016a34a3cbff3675f938662b2f8c3e@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-account.7ab3cf9d12a4e37f309bf2f4b6b9d058f24bed96@1x.png"
  },
  "medium-help-alt": {
    name: "medium-help-alt",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-help-alt.6fa4e7c73f3960257e819dbf918941cea9970a07@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-help-alt.78746a0d0eb675d602a7e633cd5b833a5bee0959@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-help-alt.2c0f14618c45230d69ac2d984156202e6a3c38a1@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-help-alt.e1c44de3e3878cc1a83e39551355e3d28a2ecd51@1x.png"
  },
  "medium-help": {
    name: "medium-help",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-help.77b8888b642909ba44d9faef6496dbf746be084d@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-help.ce5e2591cd6f199012c7f7597762bff39adcddb0@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-help.f9342db8eebaf0238e3e29d3cb8b9721999fa31e@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-help.f0e4328a40aa9037465d6ad1c6563574e0c41e67@1x.png"
  },
  "medium-inbox": {
    name: "medium-inbox",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-inbox.12baea7b34ee2ecb4e96da8ef333518e6af53133@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-inbox.47a6b55923423d3500147279a143a576731f00af@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-inbox.13894332dfb68b5dce9b166ca0c76fedf20f5bfd@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-inbox.90c09bd775380117be099dabf6a57c4d2688e691@1x.png"
  },
  "medium-lloyds-alt": {
    name: "medium-lloyds-alt",
    width: 120,
    height: 100,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-alt.86a1d66a6686e51770b2bf9f985c57e0fd61f0b6@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-alt.992dda53b35ab887913450274299b8ff2624bb1d@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-alt.b4d7a868e28a6396412aff3f5de5da39a788a789@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-alt.51bb0022e829074f9a7b6a5a5010a81de4830c4e@1x.png"
  },
  "medium-lloyds-board": {
    name: "medium-lloyds-board",
    width: 120,
    height: 100,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-board.345f51c32207a6ab24aa5957f372abfa68a16d3f@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-board.f1257a31af53365222f00bd77a0faaee5e7603fb@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-board.4d2272cb2ff7ee5a0c45ce0ac2f8e1b2dffe37d5@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds-board.679200fe858ac083bcb2357c80ad9e1bf7d1bdc6@1x.png"
  },
  "medium-lloyds": {
    name: "medium-lloyds",
    width: 120,
    height: 100,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds.b6562680ba83f9c8d6f2e2e05f353027a361728c@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds.859cc61b217c40548b8c2dbade81c4f37854f031@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds.201916aa4f42615d699cfb90848a82edfcb9fdb4@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-lloyds.60f18d49c0a564fd8d0b7681e56c3920bc993091@1x.png"
  },
  "medium-medicine": {
    name: "medium-medicine",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-medicine.4a759d144086f9b4c932138c6507fd0ef2704f5a@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-medicine.e2bbd8081eff099ae110988f4ac0df3bfbc1f351@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-medicine.96e944f20061f1cc4dc0cee970e2a842275fc66c@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-medicine.d489625860ddcf90c0eb4b48ec550f1c7262450a@1x.png"
  },
  "medium-payment-card": {
    name: "medium-payment-card",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-payment-card.53dd4c2f5f7dbf4374b27336550df0cf4e3163e7@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-payment-card.0efa3e9fcc5c8e908e17f435108191c91192129f@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-payment-card.9d8c2a35ae56d96b0c6b0dc7fa83d5e19bd93bb5@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-payment-card.8fee218804bf45a7371c912a0f9cdb7967f6c5b1@1x.png"
  },
  "medium-prescription-alt": {
    name: "medium-prescription-alt",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription-alt.9c29a6d506aa5ffd1ce9b69e1143c212a6c26d79@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription-alt.4de35115ca35b7400688cda6697e6e4e4721b22f@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription-alt.153da1d3d5204158aa9f4e3539e1c7628a236405@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription-alt.fac8d5c07074fc1dc999ae3d79018897391f5b64@1x.png"
  },
  "medium-prescription": {
    name: "medium-prescription",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription.3ae857bd68e8617b5aa2087ee29634671ff44170@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription.19fe584fd1478aac6078a2b65b6bceb99cb8636a@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription.bbda87baa7269570e17834944db95cbb683b67ab@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-prescription.01e42762e2f9ded543cf2d679025e6d9406cb6fb@1x.png"
  },
  "medium-wide-account": {
    name: "medium-wide-account",
    width: 355,
    height: 140,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-account.6a86ed415a88edd50f6e67f9470679738d86198e@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-account.da0f505707ccc4ff08a40bec359697f659a71954@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-account.bc9d82f7f7d5664f103913dbb741806d5fc9dcb2@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-account.fcb64418848d9107090e21558f771f0955c90d48@1x.png"
  },
  "medium-wide-help": {
    name: "medium-wide-help",
    width: 355,
    height: 140,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-help.bf0da89d7c46fdd1391ae6c148b72e84574e6e78@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-help.de3140995357ffa46844388b18c0a60ce774ef7b@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-help.47874d4d703da4f1ab0845ab5d829fa5e5f8d4e3@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-help.489696df05d03d1ce4db97c29f07c6bbae5df61e@1x.png"
  },
  "medium-wide-inbox": {
    name: "medium-wide-inbox",
    width: 355,
    height: 140,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-inbox.4e883fe7e0bd5dec02095867a37b107526a80460@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-inbox.dfaec56cf2852ef4024b546e661f7444c18d3d30@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-inbox.f978e38e88a9873475d99ebe88d7520b281ff3b6@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-inbox.6de53be30fae97e9b2463d685a5512ac88f8cc4f@1x.png"
  },
  "medium-wide-medicine": {
    name: "medium-wide-medicine",
    width: 355,
    height: 140,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-medicine.2fc5fc81d8c882741dadd05fcd75f1f1f090ea7e@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-medicine.a58fb67ce41ceab41b941fbbb10d7cfb9790e3c8@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-medicine.e7f8178b6f74b1a0bcd410da1453c37d14e6fd61@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/medium-wide-medicine.6e35e4ecae06734bcc7dc7674ce67cddbdf9712b@1x.png"
  },
  "small-calendar": {
    name: "small-calendar",
    width: 58,
    height: 58,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-calendar.ee867ca18f886a6942c6e73b6670aa20f03f02a3@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-calendar.4131bbe3fd1eaf5682f5ccbf23efe8ef4c96c9a9@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-calendar.1feecdd62b11cf49f58cc6381205797c286c7249@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-calendar.857ada5b40c3d933ae5a1bc6478f068a2034d4dc@1x.png"
  },
  "small-gift-box-alt": {
    name: "small-gift-box-alt",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box-alt.47c7c7be9c9dbe98108108c02bfda77e61234700@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box-alt.f64e5b3d5861a84f58014162dc5ba1dda2353b95@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box-alt.36862315f2a210cf8f0eebe465c6e9de1c5a29ec@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box-alt.e1bb6ab8fc44335a8f23d9721662403d9f3554f1@1x.png"
  },
  "small-gift-box": {
    name: "small-gift-box",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box.deac6b7082f82367174d2a2717d84349afa4b717@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box.0c9d739740cd0d345cc49cdda5be45685126c73d@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box.ea2c83effec9cb4fc6053832e13f6ff688e9e58a@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-box.ae654b87187604f1908da4ec8bf7e3ad8fe50ffd@1x.png"
  },
  "small-gift-card-floating-bow": {
    name: "small-gift-card-floating-bow",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-bow.2968c71a9925100f326a7817ff9e64fb9a69c5cd@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-bow.eeb9c833e1a234decc8320bac62349657c3920d8@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-bow.875dd4ef3c43bf765fa8bf29f926501b1ca68f45@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-bow.d56aec80a7fa1d19656c78f80ef5d62eebc8df49@1x.png"
  },
  "small-gift-card-floating-box-alt": {
    name: "small-gift-card-floating-box-alt",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box-alt.618c3be3acfe65f61dfb6e4ca8ed7e77c44eef2a@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box-alt.b1fd862d83986cf3a6013fa780d50a7a25aca07d@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box-alt.55505d3958c647b85f3c0963ab2986c8ec4c724b@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box-alt.12e2c5039de116b3f6e81fb7e6643cd6a54684f7@1x.png"
  },
  "small-gift-card-floating-box": {
    name: "small-gift-card-floating-box",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box.7b3360479f9240076e86d478b301422a7088f2d9@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box.adf90b1b7a0c3262f3c41334185e7d95ab9d800a@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box.c3eb00eb59813e41f65dce78c42eaae93b02e35e@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-floating-box.5c3c992d30962cd09d24c87f51bef2a5ad4b66df@1x.png"
  },
  "small-gift-card-holding-bow": {
    name: "small-gift-card-holding-bow",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-bow.9ddc5dfb6a8a3f1253eca291e98f4b44a667dc4b@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-bow.3ebc3de475643f66499eccee7cfaf0b02a17206d@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-bow.f44e13a6b092c86acbbf0b916c584507619c1960@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-bow.38c223c702592d9a5e2c307987ae6588a4279af1@1x.png"
  },
  "small-gift-card-holding-box-alt": {
    name: "small-gift-card-holding-box-alt",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box-alt.da4021b82c3f59d1dbd4c299346b38f5ad86fa8e@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box-alt.9cadeeb0a0f9b6f2529394bd4db16091c7821acc@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box-alt.3a335c43c8f2a8f07d9f106e49e89057c9627245@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box-alt.d59034b20c2365e0ae8fd6caa46ad67fcc930f9c@1x.png"
  },
  "small-gift-card-holding-box": {
    name: "small-gift-card-holding-box",
    width: 100,
    height: 84,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box.0111a03b5e3c8f26331fb12d109a052fc3fed4c6@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box.8c02a7955ad58a64a12359af0b4c23091b9fac60@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box.14e42874bd087eb426448ea04f17a6eaad013d14@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-gift-card-holding-box.52960de192d110eed10c9dc6a5b99ca974ee27a5@1x.png"
  },
  "small-negative": {
    name: "small-negative",
    width: 58,
    height: 58,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-negative.a8352b620209ad3dc59a30d597d1c2f2d886bedb@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-negative.d60ec365f1a2d2de0ab89ee782a6862b6633e751@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-negative.347f3774f30bedc7813d8081f94c32c7da00419d@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-negative.0547d715963f795c6eb02e547863fbd3d4b2f24a@1x.png"
  },
  "small-persona-family": {
    name: "small-persona-family",
    width: 58,
    height: 58,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-family.d38724a351afe1e904c8b31f61e81da38433678f@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-family.ce47fb682b7c562b3530e88286320328a6fc8641@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-family.f1ce83749435ce4538e3f2447aa891f36dbb2bfd@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-family.17fe41dcfa5d570efb0070caff81af534fa4ca27@1x.png"
  },
  "small-persona-primary": {
    name: "small-persona-primary",
    width: 58,
    height: 58,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-primary.d5f9d99208090f054799e9f42808326b6ee40b68@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-primary.9512bccfdd648bfe8c35266c179266b5f1b752d4@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-primary.27857b4efc016ddc538da78552e1028fc1c26a7a@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-primary.5336678665a6439f7dbb7ce236d6673295579895@1x.png"
  },
  "small-persona-secondary": {
    name: "small-persona-secondary",
    width: 58,
    height: 58,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-secondary.5b03eae39e743302365c392968d2db2b40db8c5e@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-secondary.f9614d1b24897ad2be534822958d379de7934bf3@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-secondary.757b71af9d26583e3fb11057ca7474b3d8a34d32@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-persona-secondary.2b40d24f73619bc9433ac56f01e1238339da6206@1x.png"
  },
  "small-positive": {
    name: "small-positive",
    width: 58,
    height: 58,
    "@4x":
      "https://storage.googleapis.com/echo-illustrations/small-positive.d28a43d7f01de166375a244a07e7017462136d71@4x.png",
    "@3x":
      "https://storage.googleapis.com/echo-illustrations/small-positive.0be686d4e65a3a9615b710c333c10ac0aff7f98b@3x.png",
    "@2x":
      "https://storage.googleapis.com/echo-illustrations/small-positive.98d87e587aba94b449e2e351d716fc55c55e9815@2x.png",
    "@1x":
      "https://storage.googleapis.com/echo-illustrations/small-positive.d4f9c4696ed81d1af16375308d4b8df010f685c3@1x.png"
  }
};
